import UI from "./view/index.js";
import controller from "./controller/index.js";
UI.start();
